import { Flex, FlexProps } from '@chakra-ui/react';
import colors from 'src/theme/colors';
import useDetectIos from 'src/hooks/useDetectIos';
import { useMenuContext } from '../../MenuContext';
import useMenuWidth from '../../hooks/useMenuWidth';

export const MENU_CLOSED_WIDTH = '72px';
export const MENU_OPEN_WIDTH = '260px';

export default function SidebarMenuContainer({
  children,
  menuState,
  ...props
}: FlexProps & { menuState: ReturnType<typeof useMenuContext>[0] }) {
  const isIos = useDetectIos();
  const menuWidth = useMenuWidth();

  return (
    <Flex
      as="nav"
      direction="column"
      px={menuState === 'open' ? '20px' : '12px'}
      w={menuWidth}
      top={0}
      height={
        isIos
          ? 'calc(100vh - env(safe-area-inset-bottom, 0px) - env(safe-area-inset-top, 0px))'
          : '100vh'
      }
      minH="640px"
      position="sticky"
      zIndex="100"
      overflow="initial"
      bg={`linear-gradient(180deg, ${colors.podcastPurple} 8.33%, ${colors.podcastPurple800} 100%);`}
      {...props}
    >
      {children}
    </Flex>
  );
}
